export enum PaymentMethods {
    CHECK = 'CHECK',
    NOTE = 'NOTE',
    TRANSFER = 'TRANSFER',
    CREDIT_CARD = 'CREDIT_CARD',
    RESERVATION_CREDIT = 'RESERVATION_CREDIT',
}

export interface DiscountDetail {
    adjustment_date?: string;
    original_rent?: number;
    discount_amount?: number;
    discount_rent?: number;
}
